
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_bvckr_141",
  "checkbox-control": "awsui_checkbox-control_k2y2q_bvckr_174",
  "outline": "awsui_outline_k2y2q_bvckr_182"
};
  